import { CSSProperties } from "react";

export interface IDetailItem {
  label: string;
  content: string;
  hint?: string;
}

type Props = IDetailItem & {
  labelStyle?: CSSProperties;
  style?: CSSProperties;
};

const DEFAULT_LABEL_STYLE = { fontSize: "small", color: "gray" };

const DetailItem = ({
  label,
  content,
  hint,
  labelStyle = DEFAULT_LABEL_STYLE,
  style = {},
}: Props) => {
  const hintStyle = hint ? { cursor: "pointer", textDecoration: "underline dotted" } : {};

  return (
    <div style={style}>
      <span style={{ ...labelStyle, ...hintStyle }} title={hint}>
        {label}
      </span>
      <div>{content}</div>
    </div>
  );
};
export default DetailItem;
